import React, { Component } from "react";
import ReorderTable from "../../hoc/UI/ReorderTable/ReorderTable";
import {Button, Modal, ModalBody, ModalHeader, ModalFooter} from "reactstrap";
import {Formik} from "formik";
import "../../App.css";

class StakeholderRoleModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            showCreateModal: false
        };
    }

    componentDidMount() {
        this.props.fetch();
    }

    componentWillReceiveProps = (nextProps, nextContext) => {
        if (this.state.data === null) {
            this.setState({data: nextProps.roles});
        }
    }

    toggleCreateRoleModal = () => {
        this.setState(prevState => ({
            showCreateModal: !prevState.showCreateModal
        }));
    }

    updateData = d => {
        if (this.state) {
            this.setState({data: d});
        }
    }

    render() {
        const columns = [
            { Header: "Roles", accessor: "name"},
            { Header: "Display Order", accessor: "display_order", show: false},
            { Header: "", accessor: "stakeholder_role_id", show: false },
            { Header: "", accessor: "description", show: false },
        ];
        columns.forEach(h => (h.headerStyle = { fontWeight: "bold" }));
        return (
            <Modal
                isOpen={this.props.modal}
                fade
                size="sm"
                toggle={() => {
                    this.props.toggle();
                    this.setState({data: null});
                }}
                backdrop="static"
            >
                <ModalHeader toggle={() => {
                    this.props.toggle();
                    this.setState({data: null});
                }}>
                    Stakeholder Roles
                </ModalHeader>
                <ModalBody>
                    {/*
                    <div className={"text-right"}>
                        <Button
                            color="primary"
                            size="sm"
                            className="mb-2"
                            onClick={this.toggleCreateRoleModal}
                        >
                            Create New Role
                        </Button>
                    </div>
                    */}
                    <p> Drag and drop roles to change order. </p>
                    <ReorderTable
                        data={this.state.data}
                        columns={columns}
                        update={this.updateData}
                        keyName={"stakeholder_role_id"}
                        idName={"stakeholder_role_id"}
                    />
                    <Modal
                        toggle={this.toggleCreateRoleModal}
                        isOpen={this.state.showCreateModal}
                        backdrop="static"
                        fade
                    >
                        <ModalHeader toggle={this.toggleCreateRoleModal}>
                            Contact
                        </ModalHeader>
                        <ModalBody>
                            <div>
                                <small className={"d-block"}>
                                    <span style={{ color: "red" }}>*</span> required
                                </small>
                                <Formik
                                    onSubmit={(values, { setSubmitting }) => {
                                        this.toggleCreateRoleModal();
                                        this.props.add(values);
                                    }}
                                >
                                    {({ values, handleChange, handleBlur, handleSubmit }) => (
                                        <form onSubmit={handleSubmit}>
                                            <div className="form-row">
                                                <label className="col-sm-3 required">Name</label>
                                                <input
                                                    required
                                                    type="text"
                                                    name="name"
                                                    maxLength="50"
                                                    className="form-control col-sm-6"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.name}
                                                />
                                            </div>
                                            <div className="form-row">
                                                <label className="col-sm-3">Description</label>
                                                <input
                                                    type="text"
                                                    name="description"
                                                    maxLength="500"
                                                    className="form-control col-sm-6"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.description}
                                                />
                                            </div>
                                            <div className="form-row">
                                                <label className="col-sm-3">Display Order</label>
                                                <input
                                                    type="number"
                                                    name="display_order"
                                                    maxLength="30"
                                                    className="form-control col-sm-6"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.display_order}
                                                />
                                            </div>
                                            <br />
                                            <Button color="primary" type="submit">
                                                Submit
                                            </Button>{" "}
                                            <Button
                                                color="secondary"
                                                onClick={this.toggleCreateRoleModal}
                                            >
                                                Cancel
                                            </Button>
                                        </form>
                                    )}
                                </Formik>
                            </div>
                        </ModalBody>
                    </Modal>
                    <ModalFooter>
                        <Button color="primary" onClick={() => {
                            var { data } = this.state;
                            for (var i = 0; i < data.length; i++) {
                                data[i].display_order = i + 1;
                            }
                            this.props.update(data);
                            this.props.toggle();
                        }}>
                            Save
                        </Button>{" "}
                        <Button
                            color="secondary"
                            onClick={() => {
                                this.setState({data: null});
                                this.props.toggle();
                            }}
                        >
                            Cancel
                        </Button>
                    </ModalFooter>
                </ModalBody>
            </Modal>
        );
    }
}

export default StakeholderRoleModal;